module.exports = __webpack_public_path__ + "static/media/start end date.47bd968e.svg";